// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cluNCJ{display:block}.VlhnXl{width:26px;display:flex;justify-content:center;background:no-repeat;color:white;border:none;padding:0;margin:0;transition:transform .2s;cursor:pointer}.VlhnXl:hover{opacity:.7;transform:scale(1.18)}.l3rRpv{opacity:0.55}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `cluNCJ`,
	"button": `VlhnXl`,
	"disabled": `l3rRpv`
};
export default ___CSS_LOADER_EXPORT___;
